import React from "react";
import {GridContainerFlex} from "../GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {GridItemFlex} from "../GridFlex/GridItemFlex/GridItemFlex.jsx";

export const MainContentLayout = (props) => {

    return (
        <GridContainerFlex className={"main-content-layout"} style={{padding: "0 10px"}}>
            <GridItemFlex xs={12}>
                {props.children}
            </GridItemFlex>
        </GridContainerFlex>
    )
}